'use client';

import React from 'react';
import Link from 'next/link';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ListOptions from '@/components/seo/rank/ListOptions';
import { JOB_RANKING_PAGE_ROUTER_PATH } from '@/constants/router-path';
import { HOT_LEVEL } from '@/constants/job-ranking';
import { JobTitlesRankType } from '@/types/job-ranking';

const DEFAULT_SIZE = 5;

const JobTitlesRank = (props: { jobTitlesRank: JobTitlesRankType }) => {
  const { jobTitlesRank } = props;
  const [jobCategoryId, setJobCategoryId] = React.useState<string>(
    jobTitlesRank?.length > 0 ? jobTitlesRank[0].id : '',
  );

  if (!Array.isArray(jobTitlesRank) || !jobTitlesRank.length) {
    return null;
  }

  return (
    <div className="my-16">
      <h3 className="text-2xl font-semibold mb-10">热门职位榜单</h3>
      <div className="flex justify-between items-center mb-8">
        <h4 className="flex gap-2 overflow-x-scroll tablet:overflow-auto">
          {jobTitlesRank.slice(0, 6).map(({ id, name }, index) => (
            <span
              role="button"
              key={id + index}
              data-selected={id === jobCategoryId}
              className="px-8 py-2 rounded-full text-sm border border-web-tertiary font-semibold whitespace-nowrap transition-colors duration-250 data-[selected=true]:text-white data-[selected=true]:bg-web-blue-500 data-[selected=true]:border-web-blue-600 data-[selected=false]:hover:bg-web-blue-500/4 data-[selected=false]:hover:border-web-blue-600"
              onClick={() => setJobCategoryId(id)}
            >
              {name}
            </span>
          ))}
        </h4>
        <Link
          className="flex items-center font-semibold text-sm hover:underline"
          href={`${JOB_RANKING_PAGE_ROUTER_PATH}${HOT_LEVEL.id}/`}
        >
          查看全部
          <ChevronRightRoundedIcon />
        </Link>
      </div>
      {jobTitlesRank.map(({ id, name, salary_rank, open_job_rank }, index) => (
        <ul
          key={id + index}
          hidden={id !== jobCategoryId}
          className="flex gap-8 list-none !ml-0"
        >
          <ListOptions
            title="薪资收入TOP10的职位"
            subTitle={`锁定【${name}】岗的高薪职位，为你的求职谈判与职业规划提供参考。数据涨幅基于近 6 个月数据统计。`}
            options={salary_rank}
            filterId={id}
            size={DEFAULT_SIZE}
            margin="mb-0 flex-1"
            needMore={false}
          />
          <ListOptions
            title="岗位需求热榜"
            subTitle={`洞察招聘需求最旺盛的【${name}】职位，把握市场最新动向。`}
            options={open_job_rank}
            filterId={id}
            isOpenJob={true}
            size={DEFAULT_SIZE}
            margin="mb-0 flex-1"
            needMore={false}
          />
        </ul>
      ))}
    </div>
  );
};

export default JobTitlesRank;
